// Campus photo for /colleges/university-of-houston: CC BY-SA 3.0, by Another Believer, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AEzekiel_W._Cullen_Building%2C_University_of_Houston_in_2012.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-houston/; credited under the photo.
const photo = {
    "slug": "university-of-houston",
    "alt": "The Ezekiel W. Cullen Building framed by trees on the University of Houston campus in Houston, Texas",
    "src": "/colleges/university-of-houston/campus-1600.webp",
    "srcSmall": "/colleges/university-of-houston/campus-800.webp",
    "srcMid": "/colleges/university-of-houston/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-houston/og.jpg",
    "title": "Ezekiel W. Cullen Building, University of Houston in 2012",
    "author": "Another Believer",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AEzekiel_W._Cullen_Building%2C_University_of_Houston_in_2012.JPG",
    "read": "2026-10-01"
};

export default photo;
